module.exports = __webpack_public_path__ + "static/media/iguazu-falls-33.0a824077.jpg";